import { Card } from "react-bootstrap";
import FeaturesList from "../common/FeaturesList";
import ComingSoon from "../common/ComingSoon";
import {
  useListUserFlagValuesQuery,
  useUpdateUserFlagValueMutation,
} from "../../../../services/ScopeStackAPI";

const Features = (): JSX.Element => {
  const { data: flags, isLoading } = useListUserFlagValuesQuery();
  const [updateUserFlagValue] = useUpdateUserFlagValueMutation();

  return (
    <>
      <Card className="whiteBg">
        <Card.Header className="headerOverride">Preferences</Card.Header>
        <hr className="cardHeadDivider" />
        <Card.Body className="whiteBg">
          <FeaturesList
            flags={flags}
            isLoading={isLoading}
            onUpdate={(id, variation) => updateUserFlagValue({ id, variation })}
          />
        </Card.Body>
      </Card>
      <ComingSoon />
    </>
  );
};

export default Features;
